/**
 * Created by fengqian_pc on 2018/7/27.
 */

export function goDetailFun(vm, name, params) {
  sessionStorage.setItem(name, JSON.stringify(params));
  vm.$router.push({
    name: name,
    params: {
      id: params.id,
      title: params.cn_spell_name,
    },
  });
}

export function goDetailOpenFun(name, params, query) {
  sessionStorage.setItem(name, JSON.stringify(params));
  let openUrl =
      window.location.origin +
      '/yogaUniversityDetail/' +
      params.type +
      '/' +
      params.id;

  if (query && query.channels) {
    openUrl += '?channels=' + query.channels;
  }
  // window.location.href = openUrl;
  window.open(openUrl);
}



// WEBPACK FOOTER //
// ./src/assets/js/jump.js